import i from "./index268.js";
import { resolveComponent as m, createElementBlock as r, createCommentVNode as c, openBlock as n, createElementVNode as s, normalizeClass as l, Fragment as p, renderList as d, withDirectives as u, createVNode as g, toDisplayString as h, vShow as b } from "vue";
import f from "./index231.js";
const y = ["data-component"], w = ["href"];
function _(e, C, k, v, $, V) {
  const t = m("ms-arrow-right");
  return e.links.length ? (n(), r("div", {
    key: 0,
    "data-component": e.$options.name
  }, [
    s("ol", {
      class: l(["grid w-full grid-cols-1 gap-x-24", {
        "screen-m:grid-cols-2 screen-l:grid-cols-3": e.hasMaxColumns,
        "screen-m:grid-cols-2 screen-l:grid-cols-2": !e.hasMaxColumns && !e.hasSingleColumn
      }])
    }, [
      (n(!0), r(p, null, d(e.links, (o, a) => u((n(), r("li", {
        key: o.label,
        class: "border-b solid border-y-color-neutral-grey-10 group"
      }, [
        s("a", {
          class: l(["flex justify-between py-[7px] items-center text-h4-mobile", {
            hyphens: e.hasHyphens
          }]),
          href: o.url
        }, [
          s("span", null, h(o.label), 1),
          g(t, { class: "w-38 h-38 min-w-38 min-h-38 ml-16 group-hover:bg-color-brand-beige-100 group-active:bg-color-brand-beige-100 rounded-normal p-[7px]" })
        ], 10, w)
      ])), [
        [b, a + 1 <= e.amountVisibleLinks]
      ])), 128))
    ], 2)
  ], 8, y)) : c("", !0);
}
const x = /* @__PURE__ */ f(i, [["render", _]]);
export {
  x as default
};
